export default {
      id: "icon-espace-prive-usage",
      viewBox: "0 0 27 27",
      url: "../icon/" + "icons.svg#icon-espace-prive-usage",
      toString: function () {
        return this.url;
      }
    }